import React, { Component } from "react";
import styled from "styled-components";
class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <ParentDiv height={this.props.height}>{this.props.children}</ParentDiv>
    );
  }
}

export default Footer;

const ParentDiv = styled.div`
  width: 100%;
  background: #e1e5eb;
  height: ${(props) => (props.height ? props.height : "70px")};
  padding-top: 15px;
  text-align: center;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #babec3;
  font-family: Trebuchet MS;
`;
